import Vue from "vue";
import VueRouter from "vue-router";
import multiguard from "vue-router-multiguard";
import Home from "@/views/Home";
import Reports from "@/views/reports/Reports";
import UserProfile from "@/views/profile/UserProfile";
import Customers from "@/views/customers/Customers";
import Customer from "@/views/customers/Customer";
import CustomerCreate from "@/views/customers/CustomerCreate";
import EmployerCreate from "@/views/employers/EmployerCreate";
import CustomerEdit from "@/views/customers/CustomerEdit";
import CustomerReturnDetails from "@/components/customers/CustomerReturnDetails";
import CustomerCreateReturn from "@/components/customers/CustomerCreateReturn";
import CreateRole from "@/views/roles/RoleCreate";
import EditRole from "@/views/roles/RoleEdit";
import Employers from "@/views/employers/Employers";
import EmployerEdit from "@/views/employers/EmployerEdit";
import SwitchRole from "@/components/auth/SwitchRole";
import RoleList from "@/views/roles/RoleList";
import Login from "@/components/auth/Login";
import GoogleAuth from "@/components/auth/GoogleAuth";
import MobileLogin from "@/components/auth/MobileLogin";
import ForgotPassword from "@/components/auth/ForgotPassword";
import InvoiceList from "@/views/invoices/InvoicesList";
import CreateInvoice from "@/views/invoices/InvoiceCreate";
import InvoiceItems from "@/views/invoices/InvoiceItems";
import EditInvoice from "@/views/invoices/EditInvoice";
import ReceiptsList from "@/views/receipts/ReceiptsList";
import ReceiptDetails from "@/views/receipts/ReceiptDetails";
import Page403 from "@/views/errors/403.vue";
import Page404 from "@/views/errors/404.vue";
import Settings from "@/views/settings/Settings.vue";
import Products from "@/views/products/Products.vue";
import Product from "@/views/products/Product.vue";
import ProductEdit from "@/views/products/ProductEdit.vue";
import ProductCreate from "@/views/products/ProductCreate.vue";
import Suppliers from "@/views/suppliers/Suppliers.vue";
import Supplier from "@/views/suppliers/Supplier.vue";
//import SupplierEdit from "@/views/suppliers/SupplierEdit.vue";
import SupplierCreate from "@/views/suppliers/SupplierCreate.vue";
import InventoryList from "@/views/inventories/InventoryList.vue";
// import CreateInventoryForm from "@/views/inventories/InventoryCreate.vue";
import CreatePurchaseOrder from "../views/purchaseorders/CreatePurchaseOrder.vue";
import EditPurchaseOrder from "../views/purchaseorders/EditPurchaseOrder.vue";

import BinCardReport from "@/views/inventories/binCard/BinCardReport";
import PurchaseOrders from "@/views/purchaseorders/PurchaseOrders";
import PurchaseOrderItems from "@/views/purchaseorders/PurchaseOrderItem";

import GrnCreate from "@/views/grn/GrnCreate";
import GoodsReceivedNote from "@/views/grn/GoodsReceivedNote";
import GoodsReceivedNoteDetails from "@/views/grn/GoodsReceivedNoteItems";
import GrnEdit from "@/views/grn/GrnEdit";

import BatchList from "../views/batches/BatchList.vue";
import BatchCreate from "../views/batches/BatchCreate.vue";
import BatchEdit from "../views/batches/BatchEdit.vue";

import GoodsReturnCreate from "../views/GoodsReturn/GoodsReturnCreate.vue";
import GoodsReturn from "../views/GoodsReturn/GoodsReturnNote.vue";
import GoodsReturnDetails from "../views/GoodsReturn/GoodsReturnItems.vue";
import GoodsReturnEdit from "../views/GoodsReturn/GoodsReturnEdit.vue";

import StoreCreate from "../views/storesAndStocks/StoreCreate.vue";
import Stores from "../views/storesAndStocks/Stores.vue";
import StoreEdit from "../views/storesAndStocks/StoreEdit.vue";

import StockTransfer from "../views/stocktransfer/StockTransfer.vue";
import StockTransfers from "@/views/stocktransfer/StockTransfers";
import StockTransferDetails from "@/views/stocktransfer/StockTransferView.vue";

import CreatePaymentVoucher from "@/views/paymentVouchers/CreatePaymentVoucher";
import PaymentVouchers from "@/views/paymentVouchers/PaymentVouchers";
import EditVouchers from "@/views/paymentVouchers/EditPaymentVoucher";

import AddGlSubHeaders from "@/views/GlSubHeaders/AddGlSubHeader.vue";
import CreateGlAccount from "@/views/GlAccounts/CreateGlAccount.vue";

import AddOtherIncome from "../views/Income/AddOtherIncome.vue";
import OtherIncome from "../views/Income/OtherIncome.vue";
import EditOtherIncome from "../views/Income/OtherIncomeEdit.vue";
import AddOtherIncomeEntries from "../views/Income/AddOtherIncomeEntries.vue";
import OtherIncomeEntriesList from "../views/Income/OtherIncomeEntriesList.vue";
import AllOtherIncomeEntriesList from "../views/Income/AllOtherIncomeEntries.vue";
import EditOtherIncomeEntry from "../views/Income/EditOtherIncomeEntries.vue";

import AddGLTransaction from "@/views/GlTransactions/AddGLTransaction";
import GLTransactionList from "@/views/GlTransactions/GLTransactionList";
import GlAccountsList from "@/views/GlAccounts/GlAccountsList";

import ExpenseTypeList from "@/views/ExpenseType/ExpenseTypeList";
import CreateExpenseType from "@/views/ExpenseType/CreateExpenseType";
import CreateExpense from "@/views/Expense/CreateExpense";
import ExpenseList from "@/views/Expense/ExpenseList";

import CreateRequisition from "@/views/Requisition/CreateRequisition";
import RequisitionsList from "@/views/Requisition/RequisitionsList";
import RequisitionView from "../components/Requisition/RequisitionView.vue";

import BranchList from "@/views/branches/BranchList.vue";
import BranchCreate from "@/views/branches/BranchCreate.vue";
import BranchEdit from "@/views/branches/BranchEdit.vue";

import StockReport from "@/views/stocks/StockReport.vue";
import StockAdjustment from "@/views/stocks/StockAdjustment.vue";

import TaxList from "@/views/taxes/TaxList.vue";
import TaxCreate from "@/views/taxes/TaxCreate.vue";
import TaxEdit from "@/views/taxes/TaxEdit.vue";

import BankTransactions from "../views/CompanyBanks/BankTransactions.vue";
import BankAccountsList from "../views/CompanyBanks/BankAccountsList.vue";
import BankAccountCreate from "../views/CompanyBanks/BankAccountCreate.vue";
import TrialBalanceReport from "../views/GlAccounts/TrialBalanceReport.vue";

import ProductSalesReport from "@/views/reports/ProductSales.vue";
import StockdetailsReport from "@/views/reports/StockdetailsReport.vue";
import DueCustomerReport from "../views/reports/DueCustomerReport.vue";
import ProductMovementReportView from "../views/reports/ProductMovement.vue";
import CustomerSummaryReportView from "@/views/reports/CustomerSummaryReport.vue";
import TransactionReport from "../views/reports/TransactionReport.vue";

import ProductCategories from "../views/productsCategory/ProductCategories.vue";
import ProductCategoryForm from "../views/productsCategory/ProductCategoryForm.vue";
import Setup2FA from "../views/Auth/Setup2FA.vue";
import TwoFactor from "../views/Auth/TwoFactor.vue";

const ifNotAuthenticated = (to, from, next) => {
  if (!localStorage.getItem("access_token")) {
    next();
    return;
  }
  next("/");
};

const ifAuthenticated = (to, from, next) => {
  if (localStorage.getItem("access_token")) {
    next();
    return;
  }
  next("/login");
};

const hasPermission = (requiredPermission, userPermissions) => {
  return userPermissions.includes(requiredPermission);
};

const checkPermission = (requiredPermission) => (to, from, next) => {
  const userPermissions = JSON.parse(localStorage.getItem("permissions")) || [];
  if (userPermissions.length === 0) {
    next({ path: "/switch-role", query: { id: Date.now() } });
    return;
  }

  if (hasPermission(requiredPermission, userPermissions)) {
    next();
    return;
  } else {
    next("/error");
  }
};

const customerInfo = checkPermission("customer.view");
const invoicePermission = checkPermission("invoice.list");
const receiptPermission = checkPermission("receipt.list");
const SettingsPermission =
  checkPermission("setting.company_settings") ||
  checkPermission("setting.project_settings");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    meta: { activePath: "/" },
    component: Home,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/profile",
    name: "CustomerProfile",
    meta: { activePath: "profile" },
    component: UserProfile,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
    beforeEnter: ifNotAuthenticated,
  },

  {
    path: "/googleAuth",
    name: "GoogleAuth",
    component: GoogleAuth,
    beforeEnter: ifNotAuthenticated,
  },

  {
    path: "/switch-role",
    name: "SwitchRole",
    component: SwitchRole,
    beforeEnter: ifAuthenticated,
  },

  {
    path: "/app-login",
    name: "AppLogin",
    component: MobileLogin,
    beforeEnter: ifNotAuthenticated,
  },

  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    beforeEnter: ifNotAuthenticated,
  },

  {
    path: "/employers/create",
    name: "CreateEmployer",
    component: EmployerCreate,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/roles/create",
    name: "CreateRole",
    component: CreateRole,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/employers",
    name: "Employers",
    component: Employers,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/employers/edit/:uuid",
    name: "EmployerEdit",
    component: EmployerEdit,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/roles/edit/:name",
    name: "EditRole",
    component: EditRole,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    beforeEnter: multiguard([ifAuthenticated, SettingsPermission]),
  },

  {
    path: "/roles",
    name: "RoleList",
    component: RoleList,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  //products routes
  {
    path: "/product",
    name: "Products",
    component: Products,
    beforeEnter: multiguard([ifAuthenticated, checkPermission("product.list")]),
  },
  {
    path: "/product/:uuid/info",
    name: "Product",
    component: Product,
    beforeEnter: multiguard([ifAuthenticated, checkPermission("product.view")]),
  },
  {
    path: "/product/create",
    name: "ProductCreate",
    component: ProductCreate,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("product.create"),
    ]),
  },
  {
    path: "/product/edit/:uuid",
    name: "ProductEdit",
    component: ProductEdit,
    beforeEnter: multiguard([ifAuthenticated, checkPermission("product.edit")]),
  },

  {
    path: "/product-categories",
    name: "ProductCategories",
    component: ProductCategories,
    beforeEnter: multiguard([ifAuthenticated, checkPermission("product.list")]),
  },

  {
    path: "/product-category/create",
    name: "ProductCategoryCreate",
    component: ProductCategoryForm,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("product.create"),
    ]),
  },
  {
    path: "/product-category/edit/:uuid",
    name: "ProductCategoryEdit",
    component: ProductCategoryForm,
    beforeEnter: multiguard([ifAuthenticated, checkPermission("product.edit")]),
    props: true,
  },

  //supplier routes
  {
    path: "/suppliers",
    name: "Suppliers",
    component: Suppliers,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/supplier/:uuid/info",
    name: "Supplier",
    component: Supplier,
    beforeEnter: multiguard([ifAuthenticated, customerInfo]),
  },
  {
    path: "/supplier/create",
    name: "SupplierCreate",
    component: SupplierCreate,
    beforeEnter: multiguard([ifAuthenticated]),
    props: { mode: "create" },
  },
  {
    path: "/supplier/edit/:id",
    name: "SupplierEdit",
    component: SupplierCreate,
    beforeEnter: multiguard([ifAuthenticated]),
    props: (route) => ({ mode: "edit", id: route.params.id }),
  },

  //customer routes
  {
    path: "/customers",
    name: "Customers",
    component: Customers,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/customer/:uuid/info",
    name: "Customer",
    component: Customer,
    beforeEnter: multiguard([ifAuthenticated, customerInfo]),
  },

  {
    path: "/customers/create",
    name: "CustomerCreate",
    component: CustomerCreate,
    beforeEnter: multiguard([ifAuthenticated]),
  },
  {
    path: "/customers/edit/:uuid",
    name: "CustomerEdit",
    component: CustomerEdit,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/customer/:uuid/purchase-return/:returnUuid",
    name: "CustomerReturnDetails",
    component: CustomerReturnDetails,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/customer/:uuid/purchase-return-create",
    name: "CustomerReturnCreate",
    component: CustomerCreateReturn,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  //inventory routes
  {
    path: "/inventories",
    name: "Inventories",
    component: InventoryList,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  // {
  //   path: "/customer/:uuid/info",
  //   name: "Customer",
  //   component: Customer,
  //   beforeEnter: multiguard([ifAuthenticated, customerInfo]),
  // },

  // {
  //   path: "/inventories/create",
  //   name: "InventoryCreate",
  //   component: CreateInventoryForm,
  //   beforeEnter: multiguard([ifAuthenticated]),
  // },
  // {
  //   path: "/customers/edit/:uuid",
  //   name: "CustomerEdit",
  //   component: CustomerEdit,
  //   beforeEnter: multiguard([ifAuthenticated]),
  // },

  {
    path: "/reports",
    name: "Reports",
    component: Reports,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  /* Invoice Routes */
  {
    path: "/invoices",
    name: "InvoiceList",
    component: InvoiceList,
    beforeEnter: multiguard([ifAuthenticated, invoicePermission]),
  },
  {
    path: "/invoice/create",
    name: "CreateInvoice",
    component: CreateInvoice,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/invoice/edit/:uuid",
    name: "EditInvoice",
    component: EditInvoice,
    beforeEnter: multiguard([ifAuthenticated]),
    props: (route) => ({ mode: "edit", uuid: route.params.uuid }),
  },

  {
    path: "/invoice/:uuid/:invoice_number",
    name: "invoice-details",
    component: InvoiceItems,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  /* Receipt Routes */
  {
    path: "/receipts",
    name: "ReceiptList",
    component: ReceiptsList,
    beforeEnter: multiguard([ifAuthenticated, receiptPermission]),
    meta: { activePath: "receipts" },
  },
  {
    path: "/receipt/:uuid",
    name: "receipt-details",
    component: ReceiptDetails,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/error",
    name: "AccessDenied",
    component: Page403,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/purchase-orders/edit/:uuid",
    name: "UpdatePurchaseOrder",
    component: EditPurchaseOrder,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("purchase_order.edit"),
    ]),
    props: (route) => ({ uuid: route.params.uuid }),
  },

  {
    path: "/purchase-orders/create",
    name: "CreatePurchaseOrder",
    component: CreatePurchaseOrder,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("purchase_order.create"),
    ]),
  },

  {
    path: "/bin",
    name: "BinCardReport",
    component: BinCardReport,
    beforeEnter: multiguard([ifAuthenticated]),
  },
  {
    path: "/purchase-orders",
    name: "PurchaseOrderList",
    component: PurchaseOrders,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("purchase_order.list"),
    ]),
  },
  {
    path: "/purchase-orders/:uuid/:po_number",
    name: "po-details",
    component: PurchaseOrderItems,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("purchase_order.view"),
    ]),
  },
  {
    path: "/grn/create",
    name: "createGrn",
    component: GrnCreate,
    beforeEnter: multiguard([ifAuthenticated, checkPermission("grn.create")]),
  },

  {
    path: "/grn",
    name: "grn",
    component: GoodsReceivedNote,
    beforeEnter: multiguard([ifAuthenticated, checkPermission("grn.list")]),
  },
  {
    path: "/grn/:uuid",
    name: "grnDetails",
    component: GoodsReceivedNoteDetails,
    beforeEnter: multiguard([ifAuthenticated, checkPermission("grn.view")]),
  },
  {
    path: "/grn/edit/:uuid",
    name: "grnEdit",
    component: GrnEdit,
    beforeEnter: multiguard([ifAuthenticated, checkPermission("grn.edit")]),
  },
  {
    path: "/batches",
    name: "batcheList",
    component: BatchList,
    beforeEnter: multiguard([ifAuthenticated, checkPermission("batch.list")]),
  },
  {
    path: "/batches/create",
    name: "batchCreate",
    component: BatchCreate,
    beforeEnter: multiguard([ifAuthenticated, checkPermission("batch.create")]),
  },
  {
    path: "/batches/edit/:id",
    name: "batchEdit",
    component: BatchEdit,
    beforeEnter: multiguard([ifAuthenticated, checkPermission("batch.edit")]),
  },
  {
    path: "/goodsReturn",
    name: "GoodsReturn",
    component: GoodsReturn,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("goods_return_note.list"),
    ]),
  },
  {
    path: "/goodsReturn/create",
    name: "GoodsReturnCreate",
    component: GoodsReturnCreate,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("goods_return_note.create"),
    ]),
  },
  {
    path: "/goodsReturn/:uuid",
    name: "GoodsReturnDetails",
    component: GoodsReturnDetails,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("goods_return_note.view"),
    ]),
  },
  {
    path: "/goodsReturn/edit/:uuid",
    name: "GoodsReturnEdit",
    component: GoodsReturnEdit,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("goods_return_note.edit"),
    ]),
  },
  {
    path: "/stores/create",
    name: "StoreCreate",
    component: StoreCreate,
    beforeEnter: multiguard([ifAuthenticated, checkPermission("store.create")]),
  },
  {
    path: "/stores",
    name: "Stores",
    component: Stores,
    beforeEnter: multiguard([ifAuthenticated, checkPermission("store.list")]),
  },
  {
    path: "/stores/edit/:id",
    name: "StoresEdit",
    component: StoreEdit,
    beforeEnter: multiguard([ifAuthenticated, checkPermission("store.edit")]),
  },

  {
    path: "/stock-transfer/create",
    name: "StockTransfer",
    component: StockTransfer,
    beforeEnter: multiguard([ifAuthenticated]),
  },
  {
    path: "/stock-transfers",
    name: "StockTransfers",
    component: StockTransfers,
    beforeEnter: multiguard([ifAuthenticated]),
  },
  {
    path: "/transfer/:uuid",
    name: "transferDetails",
    component: StockTransferDetails,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("stock_transfer.view"),
    ]),
  },
  {
    path: "/BankTransactions",
    name: "BankTransactions",
    component: BankTransactions,
    beforeEnter: multiguard([ifAuthenticated]),
  },
  {
    path: "/BankAccounts",
    name: "BankAccountsList",
    component: BankAccountsList,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("company_bank_account.list"),
    ]),
  },
  {
    path: "/BankAccounts/create",
    name: "BankAccountsCreate",
    component: BankAccountCreate,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("company_bank_account.create"),
    ]),
  },
  {
    path: "/payment-voucher/create",
    name: "CreatePaymentVoucher",
    component: CreatePaymentVoucher,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("payment_voucher.create"),
    ]),
  },
  {
    path: "/payment-voucher",
    name: "PaymentVoucherList",
    component: PaymentVouchers,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("payment_voucher.list"),
    ]),
  },
  {
    path: "/payment-voucher/edit/:uuid",
    name: "EditPaymentVoucher",
    component: EditVouchers,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("payment_voucher.edit"),
    ]),
  },
  {
    path: "/gl-account/sub-headers/create",
    name: "AddGlSubHeaders",
    component: AddGlSubHeaders,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("gl_sub_headers.create"),
    ]),
  },
  {
    path: "/gl-account/create",
    name: "AddGlSubHeaders",
    component: CreateGlAccount,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("gl_account.create"),
    ]),
  },

  {
    path: "/other-income/create",
    name: "AddOtherIncome",
    component: AddOtherIncome,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("other_income_types.create"),
    ]),
  },

  {
    path: "/other-income",
    name: "OtherIncome",
    component: OtherIncome,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("other_income_types.list"),
    ]),
  },
  {
    path: "/other-income/edit/:uuid",
    name: "OtherIncomeEdit",
    component: EditOtherIncome,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("other_income_types.edit"),
    ]),
  },
  {
    path: "/other-income/entries/create",
    name: "AddOtherIncomeEntries",
    component: AddOtherIncomeEntries,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("income_entries.create"),
    ]),
  },
  {
    path: "/other-income/entries",
    name: "AllOtherIncomeEntries",
    component: AllOtherIncomeEntriesList,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("income_entries.list"),
    ]),
  },

  {
    path: "/other-income/entries/:id",
    name: "OtherIncomeEntries",
    component: OtherIncomeEntriesList,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("income_entries.list"),
    ]),
  },

  {
    path: "/other-income/entries/edit/:uuid",
    name: "EditOtherIncomeEntries",
    component: EditOtherIncomeEntry,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("income_entries.edit"),
    ]),
  },

  {
    path: "/GL-Transaction/Add",
    name: "AddGLTransaction",
    component: AddGLTransaction,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/GL-Transactions",
    name: "GLTransactionList",
    component: GLTransactionList,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/GL-Accounts",
    name: "GlAccountsList",
    component: GlAccountsList,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/expense-types",
    name: "ExpenseTypeList",
    component: ExpenseTypeList,
    beforeEnter: multiguard([ifAuthenticated]),
  },
  {
    path: "/expense-types/create",
    name: "CreateExpenseType",
    component: CreateExpenseType,
    beforeEnter: multiguard([ifAuthenticated]),
    props: { mode: "create" },
  },
  {
    path: "/expense-types/edit/:id",
    name: "EditExpenseType",
    component: CreateExpenseType,
    beforeEnter: multiguard([ifAuthenticated]),
    props: (route) => ({ mode: "edit", id: route.params.id }),
  },

  {
    path: "/expenses",
    name: "ExpenseList",
    component: ExpenseList,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/expenses/create",
    name: "CreateExpense",
    component: CreateExpense,
    beforeEnter: multiguard([ifAuthenticated]),
    props: { mode: "create" },
  },

  {
    path: "/expenses/edit/:id",
    name: "EditExpense",
    component: CreateExpense,
    beforeEnter: multiguard([ifAuthenticated]),
    props: (route) => ({ mode: "edit", id: route.params.id }),
  },

  {
    path: "/Requisitions",
    name: "RequisitionsList",
    component: RequisitionsList,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/Requisition/create",
    name: "CreateRequisition",
    component: CreateRequisition,
    beforeEnter: multiguard([ifAuthenticated]),
    props: { mode: "create" },
  },

  {
    path: "/Requisition/edit/:id",
    name: "EditRequisition",
    component: CreateRequisition,
    beforeEnter: multiguard([ifAuthenticated]),
    props: (route) => ({ mode: "edit", id: route.params.id }),
  },
  {
    path: "/Requisitions/:id",
    name: "requisition-details",
    component: RequisitionView,
    beforeEnter: multiguard([
      ifAuthenticated,
      checkPermission("purchase_order.view"),
    ]),
    props: (route) => ({
      id: route.params.id,
      branchId: route.query.branchId || null,
      storeIds: route.query.storeIds
        ? route.query.storeIds.split(",").map(Number)
        : [],
    }),
  },
  {
    path: "/branches",
    name: "BranchList",
    component: BranchList,
  },
  {
    path: "/branches/create",
    name: "BranchCreate",
    component: BranchCreate,
  },
  {
    path: "/branches/edit/:id",
    name: "BranchEdit",
    component: BranchEdit,
    props: true,
  },

  {
    path: "/stock-report",
    name: "StockReport",
    component: StockReport,
  },

  {
    path: "/stock-adjustment",
    name: "StockAdjustment",
    component: StockAdjustment,
  },

  {
    path: "/taxes",
    name: "TaxList",
    component: TaxList,
    beforeEnter: multiguard([ifAuthenticated]), // add permission guard if needed
  },
  {
    path: "/taxes/create",
    name: "TaxCreate",
    component: TaxCreate,
    beforeEnter: multiguard([ifAuthenticated]), // add permission guard if needed
  },
  {
    path: "/taxes/edit/:uuid",
    name: "TaxEdit",
    component: TaxEdit,
    beforeEnter: multiguard([ifAuthenticated]), // add permission guard if needed
    props: true,
  },
  {
    path: "/trial-balance",
    name: "TrialBalanceReport",
    component: TrialBalanceReport,
    beforeEnter: multiguard([ifAuthenticated]),
  },

  {
    path: "/reports/sales",
    name: "ProductSalesReport",
    component: ProductSalesReport,
    beforeEnter: multiguard([ifAuthenticated]),
  },
  {
    path: "/reports/stock",
    name: "StockdetailsReport",
    component: StockdetailsReport,
    beforeEnter: multiguard([ifAuthenticated]),
  },
  {
    path: "/reports/due-customer",
    name: "DueCustomerReport",
    component: DueCustomerReport,
    beforeEnter: multiguard([ifAuthenticated]),
  },
  {
    path: "/reports/product-movement",
    name: "ProductMovementReportView",
    component: ProductMovementReportView,
    beforeEnter: multiguard([ifAuthenticated]),
  },
  {
    path: "/reports/customer-summary",
    name: "CustomerSummaryReport",
    component: CustomerSummaryReportView,
    beforeEnter: multiguard([ifAuthenticated]),
  },
  {
    path: "/reports/transactions",
    name: "TransactionReport",
    component: TransactionReport,
    beforeEnter: multiguard([ifAuthenticated]),
  },
  {
    path: "/:catchAll(.*)",
    name: "Not Found",
    component: Page404,
    beforeEnter: multiguard([ifAuthenticated]),
  },
  {
    path: "/setup-2fa",
    name: "Setup2FA",
    component: Setup2FA,
  },
  {
    path: "/2fa",
    name: "2FA",
    component: TwoFactor,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
